import { Box } from "@material-ui/core";
import { Step, StepLabel, Stepper } from "@mui/material";

const CommonStepper = ({ steps, activeStep }) => {
  return (
    <Box marginBottom={3}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps?.map((label, index) => (
          <Step key={index}>
            <StepLabel sx={{ textTransform: "uppercase" }}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CommonStepper;
